{
  "addToFavorites": "پسندیدہ میں شامل کریں",
  "alertCondition": "الرٹ کی شرط",
  "alertCreateFailed": "قیمت الرٹ بنانے میں ناکامی۔",
  "alertCreated": "قیمت الرٹ بن گیا۔",
  "alertTargetValue": "الرٹ ہدف قیمت",
  "allChains": "تمام چینز",
  "allMarkets": "تمام",
  "buyToken": "کوائن خریدیں",
  "chain": "Chain",
  "change24h": "24 گھنٹے تبدیلی",
  "chart": "چارٹ",
  "coin": "کوائن",
  "contract": "کنٹریکٹ",
  "contractCopied": "کنٹریکٹ کاپی ہو گیا۔",
  "createAlert": "الرٹ بنائیں",
  "exchange": "ایکسچینج",
  "favorite": "پسندیدہ",
  "filteredCoins": "فلٹر شدہ کوائنز",
  "gainers": "منافع بخش",
  "holders": "Holders",
  "hot": "ہاٹ",
  "invalidAlertValue": "ایک درست مثبت عدد درج کریں۔",
  "lastUpdated": "آخری بار اپ ڈیٹ ہوا",
  "liquidity": "لیکویڈیٹی",
  "live": "لائیو",
  "liveMarketBoard": "● لائیو مارکیٹ بورڈ",
  "loading": "لوڈ ہو رہا ہے...",
  "loadingMarkets": "مارکیٹس لوڈ ہو رہی ہیں...",
  "losers": "نقصان دہ",
  "marketCap": "مارکیٹ کیپ",
  "marketCategories": "مارکیٹ کیٹیگریز",
  "marketStatus": "مارکیٹ اسٹیٹس",
  "marketsSubtitle": "منظور شدہ کوائنز، تصدیق شدہ کنٹریکٹس، لائیو چارٹس، لیکویڈیٹی اور والیوم۔",
  "marketsTitle": "ایگزالٹ مارکیٹس",
  "noApprovedCoins": "کوئی منظور شدہ کوائن موجود نہیں۔",
  "noContractFound": "کوئی کنٹریکٹ نہیں ملا۔",
  "percentChange": "% تبدیلی",
  "percentPlaceholder": "مثلاً 5",
  "price": "قیمت",
  "priceAbove": "قیمت اس سے بڑھے",
  "priceAlerts": "قیمت الرٹس",
  "priceBelow": "قیمت اس سے کم ہو",
  "pricePlaceholder": "مثلاً 50000",
  "refresh": "ریفریش",
  "removeFromFavorites": "پسندیدہ سے ہٹائیں",
  "searchCoin": "کوائن تلاش کریں...",
  "staleMarketBoard": "⚠ قیمتیں پرانی ہو سکتی ہیں",
  "status": "اسٹیٹس",
  "submittingAlert": "بنایا جا رہا ہے...",
  "symbol": "سمبل",
  "telegram": "ٹیلیگرام",
  "topGainer": "سب سے زیادہ بڑھنے والا",
  "topLoser": "سب سے زیادہ گرنے والا",
  "totalListedCoins": "کل لسٹڈ کوائنز",
  "trending": "ٹرینڈنگ",
  "volume": "والیوم",
  "volume24h": "24 گھنٹے والیوم",
  "website": "ویب سائٹ"
}